import { FestivalMainInterviewGrid, FestivalMainInterviewItem } from "./style";
import { FestivalSkeletonBlackBox } from "../../../../style/skeleton";

const RabbitFestivalMainInterviewSkeleton = () => {
  return (
    <FestivalMainInterviewGrid>
      {Array.from({ length: 4 }, (_, i) => (
        <FestivalMainInterviewItem key={i}>
          <FestivalSkeletonBlackBox width="100%" height="100%" radius="8px" />
        </FestivalMainInterviewItem>
      ))}
    </FestivalMainInterviewGrid>
  );
};

export default RabbitFestivalMainInterviewSkeleton;
